// extracted by mini-css-extract-plugin
export var aligncenter = "text-module--aligncenter--3ddd1";
export var black = "text-module--black--397a3";
export var blue = "text-module--blue--9e8d5";
export var bold = "text-module--bold--fa6ec";
export var center = "text-module--center--48e73";
export var gray = "text-module--gray--bef1e";
export var green = "text-module--green--9fbb1";
export var justify = "text-module--justify--e2cd1";
export var l = "text-module--l--3329e";
export var large = "text-module--large--85af2";
export var left = "text-module--left--57c4f";
export var lightgray = "text-module--lightgray--93f77";
export var m = "text-module--m--b168a";
export var medium = "text-module--medium--3f512";
export var none = "text-module--none--44f8b";
export var pink = "text-module--pink--7e791";
export var right = "text-module--right--84367";
export var root = "text-module--root--d5ebd";
export var s = "text-module--s--b9236";
export var small = "text-module--small--5cee0";
export var spacebetween = "text-module--spacebetween--92c6b";
export var white = "text-module--white--93556";
export var xl = "text-module--xl--0e6ac";
export var xlarge = "text-module--xlarge--3f0b0";
export var xs = "text-module--xs--36abf";
export var xxl = "text-module--xxl--0ff82";
export var xxs = "text-module--xxs--6b922";